import React, { useState, useRef, useEffect, useContext } from "react";
import { useHistory, NavLink } from "react-router-dom";
import { Grid, Image, } from 'semantic-ui-react'
import "./ContestFlowScreen.scss";
import moment from "moment";
import { Config } from "../../common"
import atar_logo from "../../assets/home/atar_logo.png";
import beginAnimated from "../../assets/begin-animated.gif";
import { StarButton } from '../../components'
import { useSelector, useDispatch } from 'react-redux'
import { triviaQuestionsById } from '../../store/TriviaRedux'
import { useTranslation } from "react-i18next";

const ContestFlow = () => {
  const history = useHistory();
  const dispatch = useDispatch()
  const [loader, setLoader] = useState(false)
  const token = useSelector((state) => state.auth.token)
  const userDetails = useSelector((state) => state.user.userDetails)
  const triviaInfo = useSelector((state) => state.trivia.triviaInfo)
  const { t, i18n } = useTranslation();
  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);

  const startTrivia = () => {
    if (userDetails.activeContest) {
      setLoader(true)
      let params = { contestantId: `${userDetails.activeContest.contestantId}/start`, token }
      dispatch(triviaQuestionsById(params))
      setTimeout(() => {
        setLoader(false)
        history.push("/StartContest");
      }, 3000)
    }
  };

  let basicDetails = Config.GetLanguage(triviaInfo, i18n.language, 'basicDetails')
  let rules = Config.GetLanguage(triviaInfo, i18n.language, 'rules')
  let title = basicDetails?.title ? basicDetails?.title : null
  return (
    <>
      <div className="container-fluid home clearall">
        <div className="contestflow_sec">
          <div className="contestflowlogo_sec">
            <NavLink
              to="">
              <Image className="contestflow_logo" src={atar_logo} />
            </NavLink>
          </div>
          <div className="lifet">
            <Grid>
              <Grid.Row columns={2}>
                <Grid.Column mobile={16} tablet={8} computer={8}>
                  <div className="experiences">
                    <video width="204" height="200" controls autoPlay muted={true}>
                      {/* <source src="https://media.gonuts.com/videos/celebrities/all/videos/kumar-sanu.mp4" type="video/mp4" /> */}
                      <source src={triviaInfo.welcomeMessageVideo} type="video/mp4" />
                      <p className="warning">Your browser does not support HTML5 video.</p>
                    </video>
                  </div>
                </Grid.Column>
                <Grid.Column mobile={16} tablet={8} computer={8}>
                  {loader ? <div className="time_right clearall textCenter"><img src={beginAnimated} width="60%" /></div> : <div className="time_right clearall">
                    <div className="experi">
                      {title && (<h5>{(title).split(' ')[0]} <span> {title.substring(title.indexOf(" ") + 1, title.length)}</span></h5>)}
                      <p>{moment.utc(triviaInfo.startDate).format('Do MMM YYYY')} - {moment.utc(triviaInfo.endDate).format('Do MMM YYYY')}</p>
                      <div className="white_border"></div>
                    </div>
                    <div className="about clearall">
                      <h5>Rules of the contest</h5>
                      {triviaInfo && triviaInfo.rules && (
                        <ul className="circle">
                          {rules.map((item, key) => <li key={key}>{item}</li>)}
                        </ul>
                      )}
                    </div>
                    <div className="deewans clearall destops">
                      {!loader && (<StarButton background={'mainBg'} width="375px" title={t("contestflow.btn")} onClickAction={startTrivia} disableStar={false} />)}
                    </div></div>}
                </Grid.Column>
              </Grid.Row>
            </Grid>


          </div>
        </div>
        <div className="mobiles">
          {!loader && (<StarButton background={'mainBg'} width="375px" title={t("contestflow.btn")} onClickAction={startTrivia} disableStar={false} />)}
        </div>
      </div>
    </>
  );
};

export default ContestFlow
